module.exports = __webpack_public_path__ + "static/img/about-02.d272f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-02.jpg
// module id = Y6Ph
// module chunks = 0